import { initialMLOState, IMLOState } from '../state/mlo.state';
import { MLOAction, EMLOActions } from '../actions/mlo.action';
import { getAllMLODetails } from '../selectors/mlo.selector';



export function mloReducers(state = initialMLOState, action: MLOAction): IMLOState {
    switch (action.type) {

        case EMLOActions.GetAllMLODetails: {
            // console.log(action.payload)
            return {
                ...state,
                getAllMLODetails: action.payload,
                getMLOErrorMessage: null
            };
        }
        case EMLOActions.SetMLOSuccess: {
            
            return {
                ...state,
                getMLOSuccessMessage: action.payload,
                getMLOErrorMessage: null
            };
        }
        case EMLOActions.SetMLOError: {
            return {
                ...state,
                getMLOErrorMessage: action.payload,
                getMLOSuccessMessage: null,
                getAllMLODetails: null
            };
        }

        case EMLOActions.GetMLOInternalCodeSuccess: {
            return {
                ...state,
                getMLOInternalCode: action.payload,
                getMLOErrorMessage: null
            }
        }
        case EMLOActions.InactivateMLCSuccess: {
            return {
                ...state,
                inactivateMLCSuccess: action.payload,
                getMLOErrorMessage: null
            }
        }
        case EMLOActions.StartMLCSuccess: {
            return {
                ...state,
                startMLCSuccess: action.payload,
                getMLOErrorMessage: null
            }
        }
        case EMLOActions.CloseMLCSuccess: {
            return {
                ...state,
                closeMLCSuccess: action.payload,
                getMLOErrorMessage: null
            }
        }
        case EMLOActions.GetAllOlderMlcsSuccess: {
            return {
                ...state,
                getOlderMlcsSuccess: action.payload,
                getOlderMlcsError: null
               
            }
        }
        case EMLOActions.GetAllOlderMlcsError: {
            return {
                ...state,
                getOlderMlcsError: action.payload,
                getOlderMlcsSuccess: null
               
            }
        }
        case EMLOActions.SetMLCByIdSuccess: {
            return {
                ...state,
                getMLCDetailsByIdSuccess: action.payload,
                getMLCDetailsByIdError: null
               
            }
        }
        case EMLOActions.SetMLCByIdError: {
            return {
                ...state,
                getMLCDetailsByIdError: action.payload,
                getMLCDetailsByIdSuccess: null
               
            }
        }
        case EMLOActions.GetAllClosedMlcsSuccess: {
            return {
                ...state,
                getAllClosedMlcsSuccess: action.payload,
                getAllClosedMlcsError: null
               
            }
        }
        case EMLOActions.GetAllClosedMlcsError: {
            return {
                ...state,
                getAllClosedMlcsError: action.payload,
                getAllClosedMlcsSuccess: null
               
            }
        }
        case EMLOActions.GetClosedMlcByIdSuccess: {
            return {
                ...state,
                getClosedMlcByIdSuccess: action.payload,
                getClosedMlcByIdError: null
               
            }
        }
        case EMLOActions.GetClosedMlcByIdError: {
            return {
                ...state,
                getClosedMlcByIdError: action.payload,
                getClosedMlcByIdSuccess: null
               
            }
        }
        case EMLOActions.GetActivateMLCSuccess: {
            return {
                ...state,
                getActivateMLCSuccess: action.payload,
                getActivateMLCError: null
               
            }
        }
        case EMLOActions.GetActivateMLCError: {
            return {
                ...state,
                getActivateMLCError: action.payload,
                getActivateMLCSuccess: null
               
            }
        }
        case EMLOActions.GetEditClosedMlcsSuccess: {
            return {
                ...state,
                getEditClosedMlcsSuccess: action.payload,
                getEditClosedMlcsError: null
               
            }
        }
        case EMLOActions.GetEditClosedMlcsError: {
            return {
                ...state,
                getEditClosedMlcsError: action.payload,
                getEditClosedMlcsSuccess: null
               
            }
        }
        case EMLOActions.SetMLCByIdWithReleaseDataSuccess: {
            return {
                ...state,
                getMlcByIdWithReleaseDataSuccess: action.payload,
                getMlcByIdWithReleaseDataError: null
               
            }
        }
        case EMLOActions.SetMLCByIdWithReleaseDataError: {
            return {
                ...state,
                getMlcByIdWithReleaseDataError: action.payload,
                getMlcByIdWithReleaseDataSuccess: null
               
            }
        }
        case EMLOActions.GetFormulaAndMlcSuccess: {
            return {
                ...state,
                getFormulaAndMlcSuccess: action.payload,
                getFormulaAndMlcError: null
               
            }
        }
        case EMLOActions.GetFormulaAndMlcError: {
            return {
                ...state,
                getFormulaAndMlcError: action.payload,
                getFormulaAndMlcSuccess: null
               
            }
        }
        case EMLOActions.GetFormulaByIdForReleaseDataSuccess: {
            return {
                ...state,
                getFormulaByIdForReleaseDataSuccess: action.payload,
                getFormulaByIdForReleaseDataError: null
               
            }
        }
        case EMLOActions.GetFormulaByIdForReleaseDataError: {
            return {
                ...state,
                getFormulaByIdForReleaseDataError: action.payload,
                getFormulaByIdForReleaseDataSuccess: null
               
            }
        }
        case EMLOActions.GetSendMailWhenCreateMLCSuccess: {
            return {
                ...state,
                getSendMailwhenCreateMLCSuccess: action.payload,
                getSendMailwhenCreateMLCError: null
               
            }
        }
        case EMLOActions.GetSendMailWhenCreateMLCError: {
            return {
                ...state,
                getSendMailwhenCreateMLCError: action.payload,
                getSendMailwhenCreateMLCSuccess: null
               
            }
        }
        case EMLOActions.GetSendMailtoWarehouseUsersSuccess: {
            return {
                ...state,
                getSendMailtoWarehouseUsersSuccess: action.payload,
                getSendMailtoWarehouseUsersError: null
               
            }
        }
        case EMLOActions.GetSendMailtoWarehouseUsersError: {
            return {
                ...state,
                getSendMailtoWarehouseUsersError: action.payload,
                getSendMailtoWarehouseUsersSuccess: null
               
            }
        }
        case EMLOActions.GetCloseMlcUserActionSuccess: {
            return {
                ...state,
                getCloseMlcUserActionSuccess: action.payload,
                getCloseMlcUserActionError: null
               
            }
        }
        case EMLOActions.GetCloseMlcUserActionError: {
            return {
                ...state,
                getCloseMlcUserActionError: action.payload,
                getCloseMlcUserActionSuccess: null
               
            }
        }
        default: {   
            return state;
          }
    }

}